import { render, staticRenderFns } from "./zhi-neng-jian-bao.vue?vue&type=template&id=a630b722&scoped=true"
import script from "./zhi-neng-jian-bao.vue?vue&type=script&lang=js"
export * from "./zhi-neng-jian-bao.vue?vue&type=script&lang=js"
import style0 from "./zhi-neng-jian-bao.vue?vue&type=style&index=0&id=a630b722&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_00c06ca9196352b30e67b45b8b60d79f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a630b722",
  null
  
)

export default component.exports